import React, { useState } from 'react';
import ListView from './ListView';
import BulkImportSkills from '../components/BulkImportSkills';
import AddSkill from '../components/AddSkill';
import { apiPost } from '../lib/api';
import { canManage } from '../lib/roles';

export default function Skills() {
  const [reloadKey, setReloadKey] = useState(0);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const bump = () => setReloadKey((k) => k + 1);

  async function enableOne(row) {
    setBusy(true);
    setMsg('');
    try {
      await apiPost(`/skills/${row.id}/enable`, {});
      setMsg(`Enabled ${row.key}`);
      bump();
    } catch (e) {
      setMsg(String(e.message || e));
    } finally {
      setBusy(false);
    }
  }

  async function enableAnthropicDrafts() {
    if (!window.confirm('Enable all Anthropic-polled draft skills?')) return;
    setBusy(true);
    setMsg('');
    try {
      const res = await apiPost('/skills/enable-bulk', { anthropic_only: true });
      setMsg(`Enabled ${res.enabled_count || 0} Anthropic skill(s).`);
      bump();
    } catch (e) {
      setMsg(String(e.message || e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      {msg && (
        <div className="status status--muted" style={{ margin: '0.75rem 1.25rem 0' }}>
          {msg}
        </div>
      )}
      <ListView
        icon="skills"
        title="Skill Registry"
        subtitle="Add skills seamlessly from a URL, manual form, or suggested list — then govern lifecycle and review."
        path="/skills"
        columns={['id', 'key', 'name', 'lifecycle', 'risk_tier', 'trust', 'review', 'quarantined']}
        mapRow={(r) => r}
        queryParam="name"
        reloadKey={reloadKey}
        actions={(
          <>
            {canManage() && (
              <button
                type="button"
                className="btn-secondary"
                disabled={busy}
                onClick={enableAnthropicDrafts}
                title="Flip all Anthropic poller drafts to enabled"
              >
                Enable Anthropic drafts
              </button>
            )}
            <AddSkill onImported={bump} />
            <BulkImportSkills onImported={bump} />
          </>
        )}
        rowActions={
          canManage()
            ? (row) =>
                row.lifecycle === 'draft' || row.lifecycle === 'disabled' ? (
                  <button
                    type="button"
                    className="btn-primary btn-small"
                    disabled={busy}
                    onClick={() => enableOne(row)}
                  >
                    Enable
                  </button>
                ) : (
                  <span className="cell-muted">—</span>
                )
            : undefined
        }
      />
    </>
  );
}
